export enum MobileLimits {
  AutoSwitch = 20,
  SimSwap = 50,
  SimLock = 1,
  SimUnlock = 1,
  SimOrder = 1,
}
